import LocalTime from 'local-time';

import 'intersection-observer';

import 'javascripts/pages/timeline/show';
import 'scss/timeline.scss';

LocalTime.start();
